import $ from 'jquery';

/**
 * Updates computed field values and visibility.
 *
 * @param {Object} params
 * @param {Array.<Object>} params.fields List of computed field descriptors to update.
 * @param {Object} params.valueObj Map of field names to computed values.
 */
export function setComputedFields({ fields = [], valueObj = {} } = {}) {
    fields.forEach((field) => {
        const $field = $(field.idSelector);
        const value = valueObj[field.name] ?? '';

        $field.find('.js-computed-field-value').text(value);
        $field.toggleClass('hidden', value === '' && !!field.shouldHideIfEmpty);
    });
}

/**
 * Toggles select/input state for computed select fields.
 *
 * @param {Object} params
 * @param {jQuery} params.$select The computed select element.
 * @param {jQuery} params.$input The custom input element paired with the select.
 * @param {number} params.selectedValue Selected value to evaluate as present/absent.
 */
export function toggleComputedSelectCustomInput({ $select, $input, selectedValue }) {
    const hasValueSelected = !!selectedValue;
    $input.parent().toggleClass('hidden', hasValueSelected);
    $select.toggleClass('computed-select-custom', !hasValueSelected);

    if ($select.hasClass('computed-select-custom')) {
        $input.focus();
    }
}
